"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.icons = exports.makeSvgKey = exports.NO_ATTRIBUTION = exports.WITH_ATTRIBUTION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge3 = require("lodash/merge");

var _merge4 = _interopRequireDefault(_merge3);

var _omit = require("lodash/omit");

var _omit2 = _interopRequireDefault(_omit);

var _union = require("lodash/union");

var _union2 = _interopRequireDefault(_union);

var _find = require("lodash/find");

var _find2 = _interopRequireDefault(_find);

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WITH_ATTRIBUTION = exports.WITH_ATTRIBUTION = "WITH_ATTRIBUTION";
var NO_ATTRIBUTION = exports.NO_ATTRIBUTION = "NO_ATTRIBUTION";

var makeSvgKey = exports.makeSvgKey = function makeSvgKey(attribution) {
    return "raw_svg_" + attribution.toLowerCase();
};

var icons = exports.icons = function icons() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var arrays = {},
        icons = {},
        nextState = {},
        imgChoices = void 0;

    switch (action.type) {
        case actionTypes.FETCH_HERO_ICON_SUCCESS:
            nextState = action.response;
            var keys = [];
            if (state.keys !== undefined) {
                keys = state.keys;
            } else if (state.featured_icons !== undefined) {
                keys = state.featured_icons.keys;
            }
            keys.forEach(function (iconId) {
                if (!nextState.keys) {
                    return;
                }
                if (iconId === nextState.keys[0]) {
                    nextState = (0, _omit2.default)(nextState, "keys");
                }
            });
            nextState = (0, _merge4.default)({}, state, nextState);
            nextState = (0, _merge4.default)({}, nextState, {
                active_icon: { id: action.icon_id }
            });
            return nextState;
            break;
        case actionTypes.SEARCH_ICONS_SUCCESS:
            arrays = {
                union: ["keys"],
                replace: ["counts"]
            };

            icons = action.response;
            if (state.keys) {
                if (state.keys.length > 0) {
                    icons.keys.forEach(function (iconId) {
                        nextState = mergeEntity("icons", iconId, state, icons, arrays);
                    });
                } else {
                    nextState = Object.assign({}, state, icons);
                }
            } else {
                nextState = Object.assign({}, state, icons);
            }
            nextState.result = action.type;
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.FETCH_VIEW_MORE_ICONS_SUCCESS:
            arrays = {
                union: ["keys"],
                replace: ["counts"]
            };

            icons.viewMore = action.response;
            if (icons.viewMore.keys.length > 0) {
                icons.viewMore.keys.forEach(function (uploadId) {
                    nextState = mergeEntity("icons", uploadId, state, icons, arrays);
                });
            } else {
                nextState = Object.assign({}, state);
                nextState.viewMore = {
                    total_related_count: 0,
                    keys: []
                };
            }
            if (state.viewMore !== undefined) {
                var _icon = state.viewMore[action.iconId];
                if (_icon !== undefined) {
                    nextState[_icon.id] = _icon;
                }
            }
            nextState.result = action.type;
            nextState.viewMore.iconId = action.iconId;
            return Object.assign({}, state, nextState);
            break;
        case actionTypes.FETCH_ICONS_SUCCESS:
            nextState = action.response;
            nextState.searchQuery = action.searchQuery;
            if (state.searchQuery !== undefined) {
                if (state.searchQuery !== nextState.searchQuery) {
                    nextState.colorPalette = state.colorPalette;
                    nextState.imgChoices = state.imgChoices;
                    nextState.selectedColor = state.selectedColor;
                    nextState.show_icon_detail = state.show_icon_detail;
                    return (0, _merge4.default)({}, nextState);
                }
            } else {
                return (0, _merge4.default)({}, state, nextState);
            }
            break;
        case actionTypes.FETCH_PLUGIN_ICONS_SUCCESS:
            nextState = action.response;
            return (0, _merge4.default)({}, state, nextState);
            break;
        case actionTypes.FETCH_SVG_DATA:
            return (0, _merge4.default)({}, state, {
                active_icon: {
                    id: action.iconId,
                    loadingRawSVG: true
                }
            });
            break;
        case actionTypes.FETCH_SVG_DATA_FAILURE:
            return (0, _merge4.default)({}, state, {
                active_icon: {
                    loadingRawSVG: false
                }
            });
            break;
        case actionTypes.FETCH_SVG_DATA_SUCCESS:
            var iconId = action.iconId,
                attribution = action.attribution;


            var icon = state.featured_icons && state.featured_icons[action.iconId];
            if (!icon) {
                icon = state[action.iconId];
            }

            var svgKey = void 0;

            if (attribution) {
                svgKey = makeSvgKey(attribution);
                if (icon) {
                    if (state.featured_icons) {
                        state.featured_icons[action.iconId] = (0, _merge4.default)({}, icon, _defineProperty({}, svgKey, action.response));
                    } else {
                        state[action.iconId] = (0, _merge4.default)({}, icon, _defineProperty({}, svgKey, action.response));
                    }
                } else {
                    console.warn(action.iconId, "not found");
                    state[action.iconId] = _defineProperty({
                        id: action.iconId
                    }, svgKey, action.response);
                }
            } else {
                svgKey = attribution ? makeSvgKey(attribution) : makeSvgKey(NO_ATTRIBUTION);
            }

            var active_icon = state.active_icon;

            if (!active_icon || active_icon.id == action.iconId) {
                var _active_icon;

                active_icon = (_active_icon = {
                    id: action.iconId,
                    raw_svg: action.response
                }, _defineProperty(_active_icon, svgKey, action.response), _defineProperty(_active_icon, "loadingRawSVG", false), _active_icon);
            }

            return (0, _merge4.default)({}, state, {
                active_icon: active_icon
            });
        case actionTypes.SAVE_CLEANED_SVG:
            return (0, _merge4.default)({}, state, {
                active_icon: { cleaned_svg: action.cleanedSVGData }
            });
            break;
        case actionTypes.GET_COLOR_PNG_SUCCESS:
            return (0, _merge4.default)({}, state, {
                active_icon: {
                    encoded_png: action.response
                }
            });
            break;
        case actionTypes.FETCH_ICON_SUCCESS:
            nextState = action.response;
            if (nextState[action.iconId] && state[action.iconId] && nextState[action.iconId].icon_url.includes("cloudfront.net")) {
                // until api icon lookup is updated dont use old cloudfront urls

                nextState[action.iconId].icon_url = state[action.iconId].icon_url;
                nextState[action.iconId].preview_url = state[action.iconId].preview_url;
                nextState[action.iconId].preview_url_42 = state[action.iconId].preview_url_42;
                nextState[action.iconId].preview_url_84 = state[action.iconId].preview_url_84;
            }
            // NOTE: this may need to be added back and changed for the new hero
            // nextState = omit(nextState, "keys");
            nextState = (0, _merge4.default)({}, state, nextState);
            return nextState;
            break;
        case actionTypes.SET_ACTIVE_ICON:
            return (0, _merge4.default)({}, state, { active_icon: { id: action.icon_id } });
            break;
        case actionTypes.DOWNLOAD_SET_FLOW_ACTIVE:
            {
                var _icon2 = action.icon;

                var cached = void 0;

                if (state.featured_icons) {
                    cached = state.featured_icons[_icon2.id];
                } else {
                    cached = state[_icon2.id];
                }

                var _active_icon2 = (0, _merge4.default)({}, cached, {
                    id: _icon2.id
                });

                return _extends({}, state, {
                    active_icon: _active_icon2
                });
            }
        case actionTypes.CLEAR_ACTIVE_ICON:
            nextState = (0, _merge4.default)({}, state);
            nextState = (0, _omit2.default)(nextState, "active_icon");
            return nextState;
            break;
        case actionTypes.SET_ICON_COLOR_PALETTE:
            return (0, _merge4.default)({}, state, {
                colorPalette: action.color.customColors,
                selectedColor: action.color.selectedColor
            });
            break;
        case actionTypes.GET_ICON_META_DATA:
            var localStoragePalette = localStorage.getItem("customColorPalette"),
                selectedColor = localStorage.getItem("selectedColor");

            imgChoices = localStorage.getItem("imgChoices");

            if (localStoragePalette === null) {
                localStoragePalette = [{ hex: "#EC5D57" }, { hex: "#F38F19" }, { hex: "#F5D327" }, { hex: "#70C041" }, { hex: "#51A7F9" }, { hex: "#B36AE2" }];
            } else {
                localStoragePalette = JSON.parse(localStoragePalette);
            }

            if (selectedColor === null) {
                selectedColor = "#000000";
            } else {
                if (selectedColor === "undefined" || selectedColor === undefined) {
                    localStorage.removeItem("selectedColor");
                    selectedColor = "#000000";
                } else {
                    selectedColor = JSON.parse(selectedColor).hex;
                }
            }

            if (imgChoices === null) {
                var sizeKeys = ["24", "84", "150", "300", "600", "1200", "custom"],
                    imgSizes = {};
                sizeKeys.forEach(function (size) {
                    imgSizes[size] = { size: size + "px" };

                    if (size === "custom") {
                        imgSizes[size] = { size: "" };
                    }
                });

                imgChoices = {
                    sizes: imgSizes,
                    keys: sizeKeys,
                    selectedSize: "300px"
                };
            } else {
                imgChoices = JSON.parse(imgChoices);
            }

            nextState = (0, _merge4.default)({}, state, {
                colorPalette: localStoragePalette,
                selectedColor: { hex: selectedColor },
                imgChoices: imgChoices
            });
            return nextState;
            break;
        case actionTypes.SET_ICON_SIZE:
            // set local storage
            imgChoices = {};
            imgChoices["sizes"] = action.imgChoices.sizes;
            imgChoices["selectedSize"] = action.imgChoices.selectedSize;
            imgChoices["keys"] = action.imgChoices.keys;
            if (window.localStorage) {
                localStorage.setItem("imgChoices", JSON.stringify(imgChoices));
            }

            nextState = (0, _merge4.default)({}, state, {
                imgChoices: action.imgChoices
            });
            break;
        case actionTypes.SHOW_ICON_DETAIL:
            nextState = {
                show_icon_detail: true
            };
            return (0, _merge4.default)({}, state, nextState);
            break;

        case actionTypes.HIDE_ICON_DETAIL:
            return (0, _merge4.default)({}, state, {
                show_icon_detail: false
            });
            break;

        case actionTypes.FETCH_FEATURED_COLLECTIONS_SUCCESS:
            nextState = action.response;
            return (0, _merge4.default)({}, state, {
                featured_collections: _defineProperty({}, action.collectionId, nextState)
            });
            break;
        case actionTypes.FETCH_BEST_COLLECTIONS_SUCCESS:
            arrays = {
                union: ["keys"],
                replace: ["counts"]
            };

            if (action.page === 1) {
                // if first page, replace all arrays with new data - no union merge
                arrays.replace = arrays.replace.concat(arrays.union.splice(0));
            }

            icons = { featured_icons: action.response };
            if (state.featured_icons) {
                if (state.featured_icons.keys.length > 0) {
                    icons.featured_icons.keys.forEach(function (iconId) {
                        nextState = mergeEntity("featured_icons", iconId, state.featured_icons, icons.featured_icons, arrays);
                        nextState = { featured_icons: nextState };
                    });
                } else {
                    nextState = Object.assign({}, state, icons);
                }
            } else {
                nextState = Object.assign({}, state, icons);
            }
            nextState.result = action.type;
            return Object.assign({}, state, nextState);
            break;
        case actionTypes.FETCH_FORT_ICON_SUCCESS:
            nextState = action.response;
            return (0, _merge4.default)({}, state, nextState);
            break;
        case actionTypes.FEATURE_ICON_SUCCESS:
            nextState = (0, _merge4.default)({}, state);
            nextState[action.icon_upload_id].featured_icon = true;
            return (0, _merge4.default)({}, state, nextState);
            break;
        case actionTypes.UNFEATURE_ICON_SUCCESS:
            nextState = (0, _merge4.default)({}, state);
            nextState[action.icon_upload_id].featured_icon = false;
            return (0, _merge4.default)({}, state, nextState);
            break;
        case actionTypes.SAVE_ICON_INFO_SUCCESS:
            nextState = (0, _merge4.default)({}, state);
            nextState[action.icon_id] = action.response.icon;
            return (0, _merge4.default)({}, state, nextState);
            break;
        case actionTypes.REGENERATE_ICON_INFO_SUCCESS:
            nextState = (0, _merge4.default)({}, state);
            return (0, _merge4.default)({}, state, nextState);
            break;
        case actionTypes.DISABLE_ICON_SUCCESS:
            nextState = (0, _merge4.default)({}, state);
            nextState[action.icon_id].is_active = "0";
            return (0, _merge4.default)({}, state, nextState);
            break;
        case actionTypes.FETCH_TOTAL_ICON_COUNT_SUCCESS:
            nextState = (0, _merge4.default)({}, state);
            nextState.totalIcons = action.response.icons;
            return (0, _merge4.default)({}, state, nextState);
        // case actionTypes.SEARCH_ICONS_SUCCESS:
        //     nextState = action.response;
        //     return merge({}, state, nextState);
        default:
            return state;
            break;
    }

    return Object.assign({}, state, nextState);
};

var mergeEntity = function mergeEntity(type, id, state, newObj) {
    var arrays = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    if (state) {
        arrays.union.forEach(function (a) {
            if (newObj[a] && state[a]) {
                newObj[a] = (0, _union2.default)(state[a], newObj[a]);
            }
        });
        arrays.replace.forEach(function (a) {
            if (newObj[a] && state[a]) {
                state[a] = newObj[a];
            }
        });
        newObj = Object.assign({}, state[id], newObj);
    }

    return Object.assign({}, state, newObj);
};